import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import swal from 'sweetalert2';
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SelectionModel } from '@angular/cdk/collections';
import { orderStatusApproveRejet } from './order-management-model';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DeletePopupComponent } from '../../popups/delete-popup/delete-popup.component';
import { EncryptionService } from '../../service/encryption.service';
import { HelperService } from '../../service/helper.service';
import { CustomerManageOrdersService } from '../../service/cutomer-manage-order.service';
import { ApproveRejectOrderComponent } from '../../popups/approve-reject-order/approve-reject-order.component';
import FileSaver from 'file-saver';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-manage-orders',
  templateUrl: './manage-orders.component.html',
  styleUrls: ['./manage-orders.component.scss']
})
export class ManageOrdersComponent implements OnInit {
  selection = new SelectionModel<any>(true, []);
  sidebarMenuName: string;
  orderStatusApproveRejet = orderStatusApproveRejet;
  private subject: Subject<string> = new Subject();
  page: any = 1;
  itemsPerPage: any = '10';
  totalItems: any = 0;
  limit: any = 10;
  search: any = '';
  sortBy: any = '';
  sortKey = '';
  sortClass: any = 'down';
  noRecordFound = false;
  filter: any;
  public requestPara = { search: '', page: 1, limit: 10, sortBy: '', sortKey: '', status: 1 };
  @ViewChild('searchBox') myInputVariable: ElementRef;
  @ViewChild('table') table: MatTable<any>;
  manageOrderData: any = new MatTableDataSource([]);
  orderIds = [];
  companyId: any;
  manageOrderRolePermission: any;
  pending = 0;
  rejected = 0;
  approved = 0;
  isNotClickedTab = false;
  selectedTab: any;
  saveTabInfo: any = '';
  totalCounttabs: any = 0;
  refuse = 0;
  reviewOffer = 0;
  Inprogress = 0;
  manageOrderTabbing = [];
  statusLabel: string;
  sliderChecked: boolean;
  selectedIndex: any;
  currentTab: any;
  APIService: any;
  loginUserId: any;
  fileURL = null;

  constructor(
    public dialog: MatDialog, private http: HttpClient,
    private helper: HelperService,
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private ApiService: CustomerManageOrdersService,
    private security: EncryptionService,
  ) {
    this._setSearchSubscription();
  }

  documentDisplayedColumns: string[] = ['select', 'wheelAction', 'proposalId', 'orderTitle', "details", 'createdAt', 'statusReason', 'action'];

  ngOnInit(): void {
    this.sideMenuName();
    this.settabsCount();
    let str = this.security.decryptionAES(localStorage.getItem("credentials"));
    const credentials = str;
    if (credentials) {
      const authUser: any = JSON.parse(credentials);
      this.companyId = authUser.person.id;
    }

    const loginUser = this.security.getDataFromLocalStorage('NPLoginId');
    this.loginUserId = JSON.parse(loginUser);
    if (this.loginUserId) {
      this.getTotalCount();
    }
    this.ApiService.pagination.pipe(take(1)).subscribe(res => {
      this.pageChanged(res.page, res.limit)
    });
  }

  sideMenuName() {
    this.sidebarMenuName = this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.title'),
    this.helper.sideMenuListName.next(this.sidebarMenuName);
  }
  
  resetStatus() {
    this.pending = 0;
    this.rejected = 0;
    this.approved = 0;
    this.refuse = 0;
    this.reviewOffer = 0;
    this.Inprogress = 0;
  }

  onRefreshTable() {
    this.selection.clear();
    this.search = '';
    this.myInputVariable.nativeElement = '';
    this.pageChanged(1);
    document.body.classList.add('spin-animation');
    setTimeout(() => {
      document.body.classList.remove('spin-animation');
    }, 1000);
  }

  async tabChangedClick(statusType): Promise<void> {
    this.isNotClickedTab = true;
    this.requestPara.search = "";
    this.search = '';
  }

  async tabChanged(statusType): Promise<void> {
    this.selectedIndex = Number(statusType.tab.ariaLabel);
    const request = {
      search: '',
      page: 1,
      limit: this.itemsPerPage,
      sortBy: '',
      sortKey: '',
    };
    this.getManageOrderListing(request);
    this.pageChanged(1)
  }

 

  onKeyUp(searchTextValue: any): void {
    this.selection.clear();
    this.subject.next(searchTextValue);
  }

  resetSearch(): void {
    this.search = '';
    this.myInputVariable.nativeElement.value = '';
    this.page = 1;
    this.selection.clear();
    this.getManageOrderListing(this.requestPara = {
      page: 1,
      limit: this.limit,
      search: '',
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab
    });
  }

  private _setSearchSubscription(): void {
    this.subject.pipe(
      debounceTime(500)
    ).subscribe((searchValue: string) => {
      this.page = 1;
      this.selection.clear();
      this.getManageOrderListing(this.requestPara = {
        page: 1,
        limit: this.limit,
        search: this.search,
        sortBy: this.sortBy,
        sortKey: this.sortKey,
        status: this.selectedTab
      });
    });
  }

  changeItemsPerPage(event): void {
    this.page = 1;
    this.itemsPerPage = event;
    this.selection.clear();
    this.getManageOrderListing(this.requestPara = {
      page: 1, limit: this.itemsPerPage, search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab
    });
    this.limit = this.itemsPerPage;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.manageOrderData);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.manageOrderData?.length;
    return numSelected === numRows;
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  editOrder(event): void {
    this.router.navigate(['add-edit-order/' + event._id], { relativeTo: this.route });
  }

  viewOrderDetail(event): void {
    if (event.customerStatus === orderStatusApproveRejet.REVIEW_OFFER || event.customerStatus === orderStatusApproveRejet.approved || event.customerStatus === orderStatusApproveRejet.REFUSED) {
      this.router.navigate(['plan-order/' + event._id], { relativeTo: this.route });
    } else {
      this.router.navigate(['view-order-history/' + event._id], { relativeTo: this.route });
    }
  }

  removeCataLog() {
    localStorage.removeItem('sellingCatalogId')
  }

  changeSorting(sortKey, sortBy): void {
    this.sortKey = sortKey;
    this.sortBy = (sortBy === '-1') ? '1' : '-1';
    this.page = 1;
    this.selection.clear();
    this.getManageOrderListing(this.requestPara = {
      page: 1,
      limit: this.limit,
      search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab
    });
  }
  settabsCount() {
    this.manageOrderTabbing = [
      { label: 'ORDERMANAGEMENT.MANAGEORDERS.All', indexNumber: orderStatusApproveRejet.all, count: this.totalCounttabs },
      { label: 'ExecuteOrder.ManageProposal.Open', indexNumber: orderStatusApproveRejet.pending, count: this.pending },
      { label: 'ExecuteOrder.ManageProposal.In progress', indexNumber: orderStatusApproveRejet.IN_PROGRESS, count: this.Inprogress },
      { label: 'ExecuteOrder.ManageProposal.Rejected', indexNumber: orderStatusApproveRejet.reject, count: this.rejected },
      { label: 'ExecuteOrder.ManageProposal.Proposal', indexNumber: orderStatusApproveRejet.REVIEW_OFFER, count: this.reviewOffer },
      { label: 'ExecuteOrder.ManageProposal.Accepted', indexNumber: orderStatusApproveRejet.approved, count: this.approved },   
      { label: 'ExecuteOrder.ManageProposal.Refused', indexNumber: orderStatusApproveRejet.REFUSED, count: this.refuse }
    ];
  }

  getTotalCount() {
    this.ApiService.getStatusCount(this.loginUserId).subscribe((res: any) => {
      if (res.result) {
        this.resetStatus();
        // 1.APPROVED 2.PENDING 3.REJECTED  4.COMMENT
        const getdata = res.data;
        // this.totalCounttabs = getdata.map(all => all.count).reduce((acc, all) => all + acc);
        for (let i = 0; i < getdata.length; i++) {
          if (getdata[i].status == '2') {
            this.pending = getdata[i].count;
          }
          if (getdata[i].status == '1') {
            this.approved = getdata[i].count;
          }
          if (getdata[i].status == '3') {
            this.rejected = getdata[i].count;
          }
          if (getdata[i].status == '8') {
            this.reviewOffer = getdata[i].count;
          }
          if (getdata[i].status == '10') {
            this.refuse = getdata[i].count;
          }
          if (getdata[i].status == '6') {
            this.Inprogress = getdata[i].count;
          }

          this.totalCounttabs = this.pending + this.Inprogress + this.approved + this.rejected + this.reviewOffer + this.refuse;
         
        }
        this.settabsCount();

        this.helper.toggleLoaderVisibility(false);
      } else {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(res.reason),
          'info'
        );
      }
    });
  }



  changeStatusReject(req: any, id): any {
    const dialogRef = this.dialog.open(ApproveRejectOrderComponent, {
      data: {
        heading: 'ORDERMANAGEMENT.MANAGEORDERS.RejectOrderTitle',
        id,
        type: 'reject',
        status: orderStatusApproveRejet.REFUSED,
        message: 'ORDERMANAGEMENT.RejectReason',
        message1: 'Procurement_Management.Please enter internal comment'
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        swal.fire(
          '',
          this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.OrderUpdateSuccess'),
          'success'
        );
        this.getManageOrderListing(this.requestPara);
      }
    });
  }

  changeStatusApprove(req: any, id): any {
    const dialogRef = this.dialog.open(ApproveRejectOrderComponent, {
      data: {
        heading: 'ORDERMANAGEMENT.MANAGEORDERS.ApproveOrderTitle',
        id,
        type: 'accept',
        status: orderStatusApproveRejet.approved,
        message: 'ORDERMANAGEMENT.RejectReason',
        message1: 'Procurement_Management.Please enter internal comment'
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        swal.fire(
          '',
          this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.OrderUpdateSuccess'),
          'success'
        );
        this.getManageOrderListing(this.requestPara);
      }
    });
  }


  onRemove(id: any, $event) {
    const index = this.orderIds.indexOf(id);
    if (index > -1) {
      this.orderIds.splice(index, 1);
    }
    if ($event.checked) {
      this.orderIds.push(id);
    }
    if (this.orderIds.length > 0) {
      this.statusLabel = 'ORDERMANAGEMENT.MANAGEORDERS.DeleteOrderTitle';
      this.sliderChecked = true;
    } else {
      this.sliderChecked = false;
    }
  }



  getManageOrderListing(req: any): any {
    this.helper.toggleLoaderVisibility(true);
    this.requestPara = req;
    this.requestPara["status"] = this.selectedIndex;
    this.requestPara["customerId"] = this.loginUserId;
    this.ApiService.getManageOrderList(this.requestPara).pipe(take(1)).subscribe((res: any) => {
      if (res.result) {
        if (res.data.data) {
          this.manageOrderData = res.data.data;
        } else {
          this.manageOrderData = [];
        }
        this.totalItems = res.data.totalcount;
        this.noRecordFound = this.manageOrderData?.length > 0;
        this.helper.toggleLoaderVisibility(false);
        this.getTotalCount();
      }
    }, (err: any) => {
      this.helper.toggleLoaderVisibility(false);
      swal.fire(
        '',
        this.translate.instant(err?.error?.message),
        'info'
      );
    });
  }

  pageChanged(page, limit?): void {
    this.selection.clear();
    this.itemsPerPage = limit ? limit : this.itemsPerPage

    this.ApiService.pagination.next({
      page: page, limit: this.itemsPerPage, search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab
    })


    this.getManageOrderListing(this.requestPara = {
      page, limit: this.itemsPerPage, search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab
    });
    this.page = page;
  }

  deleteMultipleIds() {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: {
        message: this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.DeleteOrder'),
        heading: this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.Delete_Order'),
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const that = this
        this.helper.toggleLoaderVisibility(true);
        if (this.selection.selected.length > 0) {
          for (let i = 0; i < this.selection.selected.length; i++) {
            let paraName: string = this.selection.selected[i]._id;
            this.orderIds.push(paraName);
          }
        } else {
          this.orderIds = [];
        }
        if (this.orderIds.length > 0) {
          this.ApiService.deleteOrder({ orderIds: this.orderIds }).subscribe((res: any) => {
            if (res) {
              this.getManageOrderListing(this.requestPara);
              this.helper.toggleLoaderVisibility(false);
              this.selection.clear();
              this.orderIds = [];
              swal.fire(
                '',
                this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.DeletedSuccessfullyOrder'),
                'success'
              );
              setTimeout(() => {
                if ((this.manageOrderData?.length) == 0) {
                  let pageNumber = this.page
                  this.pageChanged(pageNumber)
                  this.table.renderRows();
                } else {
                  that.getManageOrderListing(this.requestPara);
                }
              }, 100);

            } else {
              this.helper.toggleLoaderVisibility(false);
              swal.fire(
                '',
                this.translate.instant(res.reason),
                'error'
              );
            }
          }, (err) => {
            this.helper.toggleLoaderVisibility(false);
            swal.fire(
              '',
              this.translate.instant(err?.error?.message),
              'info'
            );
          });
        } else {
          this.helper.toggleLoaderVisibility(false);
          swal.fire(
            '',
            this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.SelectAtleastOrder'),
            'info'
          );
        }
      }
    });
  }

  deleteSingleOrder(orderId) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: {
        message: this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.DeleteOrder'),
        heading: this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.Delete_Order'),
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.helper.toggleLoaderVisibility(true);
        this.ApiService.deleteOrder({ orderIds: [orderId] }).subscribe((res: any) => {
          if (res) {
            this.getManageOrderListing(this.requestPara);
            this.helper.toggleLoaderVisibility(false);
            this.selection.clear();
            this.orderIds = [];
            swal.fire(
              '',
              this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.DeletedSuccessfullyOrder'),
              'success'
            );
            setTimeout(() => {
              if ((this.manageOrderData?.length) == 0) {
                let pageNumber = this.page
                this.pageChanged(pageNumber)
                this.table.renderRows();
              } else {
                this.getManageOrderListing(this.requestPara);
              }
            }, 100);

          } else {
            this.helper.toggleLoaderVisibility(false);
            swal.fire(
              '',
              this.translate.instant(res.reason),
              'error'
            );
          }
        }, (err) => {
          this.helper.toggleLoaderVisibility(false);
          swal.fire(
            '',
            this.translate.instant(err?.error?.message),
            'info'
          );
        });
      }
    });
  }




  viewPDF(fileName: any) {
    if (fileName) {
      this.ApiService.downloadPdfFile(fileName).subscribe((res: any) => {
        if (res) {
          const blob = new Blob([res], { type: 'application/pdf' });
          this.fileURL = URL.createObjectURL(blob);
          window.open(this.fileURL);
        }
      });
    } else {
      // swal.fire(
      //   '',
      //   this.translate.instant('Procurement_Management.NoFileAvailable'),
      //   'info'
      // );
    }
  }


}

